import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
const isNullOrEmpty = (s) => s === null || s === void 0 || s.trim() === "";
const Message = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const MessageCell = ({ value }) => {
  const { t } = useTranslation("enterprise_report");
  return isNullOrEmpty(value) ? /* @__PURE__ */ React.createElement("i", null, t("message_cell.no_message")) : /* @__PURE__ */ React.createElement(Message, null, value);
};
export default MessageCell;
